import { useState } from 'react';
import { useStowageStore } from 'src/context/StowageContext';
import { TITLE_MAX_LENGTH } from 'src/factory/Stowage/StowagePlanFactory';
import usePostStowageApi from 'src/api/stowage/usePostStowageApi';
import OdfjellInputComponent from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import { sortStowagePlans } from 'src/utils/stowage/stowagePlanUtils';
import OdfjellPanel, { PANEL_CONSTANTS } from 'src/components/ui/odfjellPanel/OdfjellPanel';

const PageHeaderStowageRename = () => {
    const { activeStowagePlan, setIsRenameStowagePlanMenuOpen, stowagePlans, setStowagePlans } = useStowageStore();
    const { updateStowagePlan } = usePostStowageApi();
    const [newTitle, setNewTitle] = useState<string>(activeStowagePlan.title);

    const onRenameStowagePlan = async () => {
        const _stowagePlan = { ...activeStowagePlan, title: newTitle };
        const { updatedStowagePlan } = await updateStowagePlan(_stowagePlan);

        if (updatedStowagePlan) {
            const _stowagePlans = [...stowagePlans.filter((s) => s.stowagePlanGuid !== activeStowagePlan.stowagePlanGuid), updatedStowagePlan];
            setStowagePlans(sortStowagePlans(_stowagePlans));
        }
        setIsRenameStowagePlanMenuOpen(false);
    };

    const onClose = () => {
        setIsRenameStowagePlanMenuOpen(false);
    };

    return (
        <OdfjellPanel
            headerTitle="Rename stowage plan"
            defaultPosition="center"
            panelWidth={PANEL_CONSTANTS.MEDIUM_WIDTH}
            hasCurtain={true}
            preventOutsideClose={true}
            onCancel={onClose}
            onAction={onRenameStowagePlan}
            showCancelButton={true}
        >
            <li className="dd-item">
                <OdfjellInputComponent
                    description="Title"
                    type="text"
                    isReadOnly={false}
                    value={newTitle}
                    onChange={(e) => setNewTitle(e.event.target.value)}
                    maxTextLength={TITLE_MAX_LENGTH}
                />
            </li>
        </OdfjellPanel>
    );
};

export default PageHeaderStowageRename;
